import axios from 'axios';
import { buildUrl } from 'Util/FetchUtils';
import { CACHE_API } from 'Constants';
import { cacheType } from 'Models/Enums';

export function clearCache(cacheTypeEnum: cacheType) {
	const res = axios.delete(
		buildUrl(`${CACHE_API}/clear`, {
			cacheType: cacheTypeEnum.toString(),
		}),
	);
	return res;
}
